import router from '@/router'

export function convertNumToTime(number) {
  let sign = (number >= 0) ? 1 : -1
  number = number * sign
  const hour = Math.floor(number)
  let decpart = number - hour
  const min = 1 / 60
  decpart = min * Math.round(decpart / min)

  let minute = Math.floor(decpart * 60) + ''

  // Add padding if need
  if (minute.length < 2) {
    minute = '0' + minute
  }

  // Add Sign in final result
  sign = sign === 1 ? '' : '-'

  // Concate hours and minutes
  return sign + hour + ':' + minute
}

export function redirect(location) {
  router.push(location)
}

export function convertTimeToDetail(number) {
  let sign = (number >= 0) ? 1 : -1
  number = number * sign
  const hour = Math.floor(number)
  let decpart = number - hour
  const min = 1 / 60
  decpart = min * Math.round(decpart / min)

  let minute = Math.floor(decpart * 60) + ''

  // Add padding if need
  if (minute.length < 2) {
    minute = '0' + minute
  }

  // Add Sign in final result
  sign = sign === 1 ? '' : '-'

  // Concate hours and minutes
  if (hour < 10) {
    return '0' + hour + ':' + minute
  } else {
    return sign + hour + ':' + minute
  }
}

export function convertBackgroundImage(name) {
  if (name === 'Special class') {
    name = 'Special'
  }
  var background = name.toLowerCase().replace(' ', '-').replace("'", '')
  return background
}

export function convertAvatar(url) {
  if (url) {
    return encodeURI(decodeURI(url))
  } else {
    return 'assets/img/instructors/freshman.png'
  }
}

export function hexToRGB(h) {
  let r = 0
  let g = 0
  let b = 0

  // 3 digits
  if (h.length === 4) {
    r = '0x' + h[1] + h[1]
    g = '0x' + h[2] + h[2]
    b = '0x' + h[3] + h[3]

  // 6 digits
  } else if (h.length === 7) {
    r = '0x' + h[1] + h[2]
    g = '0x' + h[3] + h[4]
    b = '0x' + h[5] + h[6]
  }

  return +r + ',' + +g + ',' + +b
}
